export const TITLE_PROFILE_MAP: Record<string, string> = {
  'Sr Processor': 'Processing Director',
  'Loan Associate': 'Loan Associate',
  'IT Team Member': 'ActiveLink, Inc. - IT',
  'Jr Processor': 'Loan Processor',
  'Team Lead': 'Team Lead',
  'Division Lead': 'Division Lead',
  'Training Team': 'Loan Associate - Trainer',
  'Human Resources': 'HR Team',
  Admin: 'ActiveLink, Inc. - IT',
  'Doc Specialist': 'Loan Processor',
  'Loan Officer': 'Loan Associate',
}

export interface OnboardingData {
  // Identity
  firstName: string
  lastName: string
  alias: string
  email: string
  username: string
  defaultPassword: string

  // Role & Reporting
  title: string
  role: string
  profile: string
  enhancedNoteRole: string
  teamLead: string

  // Contact
  phone: string
  mobile: string
  fax: string
  extension: string

  // Integrations & Licensing
  ringCentralExtensionId: string
  isBonzoUser: boolean
  bonzoId: string
  nmlsNumber: string
  lendingPadUserId: string
  applicationLink: string

  // Skills & Operational
  leadSkills: string[]
  eligiblePullStages: string[]
  loanAmountRange: string[]
  team: string
  ultimateMaxLeads: number | ''

  // Call Center & Groups
  callCenter: string
  publicGroups: string[]

  // Loan Type Capacities
  loanTypeCapacities: Record<string, { dailyMaxLeads: number; active: boolean }>

  // Package Licenses
  packageLicenses: string[]

  // Permission Sets
  permissionSets: string[]
}

export const initialOnboardingData: OnboardingData = {
  firstName: '',
  lastName: '',
  alias: '',
  email: '',
  username: '',
  defaultPassword: '',
  title: '',
  role: '',
  profile: '',
  enhancedNoteRole: '',
  teamLead: '',
  phone: '',
  mobile: '',
  fax: '',
  extension: '',
  ringCentralExtensionId: '',
  isBonzoUser: false,
  bonzoId: '',
  nmlsNumber: '',
  lendingPadUserId: '',
  applicationLink: '',
  leadSkills: [],
  eligiblePullStages: [],
  loanAmountRange: [],
  team: '',
  ultimateMaxLeads: '',
  callCenter: '',
  publicGroups: [],
  loanTypeCapacities: {},
  packageLicenses: [],
  permissionSets: ['Sales User'],
}

export interface StepProps {
  data: OnboardingData
  updateData: (updates: Partial<OnboardingData>) => void
  setCanAdvance: (canAdvance: boolean) => void
}
